import React, { memo, useEffect } from 'react';

import { useForceUpdate } from 'Hooks';

import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';

import SadFile from 'Images/sad-file.svg';

import styles from './UnexpectedError.module.scss';

type Props = {
  reset: () => void;
};

const UnexpectedError: React.FC<React.PropsWithChildren<Props>> = ({ reset }) => {
  const update = useForceUpdate();

  useEffect(() => {
    const sub = mediator.subscribe('langChange:success', () => {
      window.setTimeout(update, 0);
    });

    return () => {
      mediator.remove(sub.id);
    };
  }, [update]);

  return (
    <div
      className={`container py-5 d-flex flex-column align-items-center justify-content-center h-100 `}
    >
      <div className="mb-4">
        <img alt="sad-file" src={SadFile} />
      </div>
      <div className={`text-danger mb-3 text-xxxl line-height-normal`}>
        {i18n.t('UnexpectedError.title')}
      </div>
      <div className={`w-100 text-center pt-3 ${styles.spacer}`}>
        <div className="text-md text-steel line-height-normal">
          {i18n.t('UnexpectedError.description')}
        </div>
      </div>
      {/* The following button will only be here when running the dev server */}
      {process.env.NODE_ENV !== 'production' ? (
        <button type="button" className="btn btn-primary mt-3" onClick={reset}>
          DEV ONLY - refresh component
        </button>
      ) : null}
    </div>
  );
};

export default memo(UnexpectedError);
